import { createSlice } from '@reduxjs/toolkit';
import { getFileStates } from 'ducks/file-states-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type FileStatesListState = ReturnType<typeof normalizeLookups<'file_state_name', 'file_state_id'>>;

const initialState: FileStatesListState = [];

const fileStatesListSlice = createSlice({
  name: Slices.FILE_STATES_LIST,
  initialState,
  reducers: {
    clearFileStatesList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFileStates.pending, () => {
        return initialState;
      })
      .addCase(getFileStates.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'file_state_name', 'file_state_id');
      })
      .addCase(getFileStates.rejected, () => {
        return initialState;
      });
  },
});

export const { clearFileStatesList } = fileStatesListSlice.actions;

export default fileStatesListSlice.reducer;
